import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login'
import StuList from '@/views/StudentList'
import StuDetail from '@/views/StudentDetail'
// 使用路由依赖
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/list',
      name: 'list',
      component: StuList
    },
    {
      path: '/detail',
      name: 'detail',
      component: StuDetail
    },
    {
      path: '/',
      name: 'login',
      component: Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js